import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
// import {
//   LinkIcon
// } from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdFossilGrade extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    return <td
      styleName='col col-grade'
      onClick={this.props.clickShareclass(this.props.shareclass) }
    >
      <div styleName={'score-wrapper-w-tail fossil-w-tail-'+this.props.shareclass.grade_fossil} >
        <span styleName='score-wrapper-grade'>
          {
            {
              '-1': 'ERROR (1)',
              '0': 'ERROR (2)',
              '1': 'A',
              '1.5': 'ENGAGEMENT',
              '2': 'B',
              '3': 'C',
              '4': 'D',
              '5': 'F',
              '6': 'ERROR (3)',
            }[this.props.shareclass.grade_fossil] || 'ERROR (4)'
          }
        </span>
        <span styleName='score-wrapper-tail'>
          {format.perc(this.props.shareclass.c2f5coogutweight)}
        </span>
      </div>
    </td>
  }
}